import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  ButtonBaseWrapper,
  ButtonIconBaseWrapper
} from './styled'

class ButtonIconBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default
      spacingRight,
      spacingLeft
    } = this.props

    return (
      <ButtonIconBaseWrapper
        className={ClassNames(
          'button-icon-base',
          // Option
          className
        )}
        theme={{
          // Default
          spacingRight,
          spacingLeft
        }}
      >
        {children}
      </ButtonIconBaseWrapper>
    )
  }

  static defaultProps = {
  }

  static propTypes = {

    className: PropTypes.string,
    spacingRight: PropTypes.PropTypes.PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    spacingLeft: PropTypes.PropTypes.PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}

export class ButtonBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default
      width,
      height,
      padding,
      paddingHorizontal,
      paddingVertical,
      paddingTop,
      paddingRight,
      paddingBottom,
      paddingLeft,
      bgColor,
      bgColorDisabled,
      bgHoverColor,
      borderWidth,
      borderStyle,
      borderColor,
      borderHoverColor,
      borderRadius,
      fluid,
      disabled,
      onClick,
      textHoverColor,
      title,
      disabledHover
    } = this.props

    return (
      <ButtonBaseWrapper
        className={ClassNames(
          'button-base',
          { 'is-fluid': fluid },
          { 'is-disabled': disabled },
          { 'is-disabled-hover': disabledHover },
          // Option
          className
        )}
        theme={{
          // Default
          width,
          height,
          padding,
          paddingHorizontal,
          paddingVertical,
          paddingTop,
          paddingRight,
          paddingBottom,
          paddingLeft,
          bgColor,
          bgHoverColor,
          bgColorDisabled,
          borderWidth,
          borderStyle,
          borderColor,
          borderHoverColor,
          borderRadius,
          textHoverColor
        }}
        onClick={onClick}
        title={title}
      >
        <div className='button-body-base'>
          {children}
        </div>
      </ButtonBaseWrapper>
    )
  }

  static Icon = ButtonIconBase

  static defaultProps = {
    bgColor: '#333333',
    bgColorDisabled: '#EEEEEE'
  }

  static propTypes = {

    className: PropTypes.string,
    width: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    height: PropTypes.PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    padding: PropTypes.PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    paddingHorizontal: PropTypes.PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    paddingVertical: PropTypes.PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    paddingTop: PropTypes.PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    paddingRight: PropTypes.PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    paddingBottom: PropTypes.PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    paddingLeft: PropTypes.PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    bgColor: PropTypes.string,
    bgHoverColor: PropTypes.string,
    bgColorDisabled: PropTypes.string,
    borderWidth: PropTypes.PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    borderStyle: PropTypes.string,
    borderColor: PropTypes.string,
    borderHoverColor: PropTypes.string,
    borderRadius: PropTypes.PropTypes.PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    fluid: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.object
    ]),
    textHoverColor: PropTypes.string,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}
